import React from 'react';
import buttonColours, { ButtonColour } from '../../helpers/buttonColours'
import ColourDisplay from '../ColourDisplay';
import GenericGridContent from './GenericGridContent';

const ButtonColourCell = ({ id }: { id: number }) => {
  const buttonColour: ButtonColour = buttonColours.find(
    (c) => c.id.toString() === (id || '').toString()
  );

  if (!buttonColour) {
    return (
      <GenericGridContent
        content={[
          {
            text: 'common.none',
            shouldTranslate: true,
            typographyProps: { variant: 'body2' },
          },
        ]}
      />
    );
  }

  return <ColourDisplay name={buttonColour.name} colour={buttonColour.colour} />;
};

export default ButtonColourCell;
